import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import {
    setInfosMail,
    formatVariableTransfert,
    verifyDataEnter,
    verifyPattern,
    getInternalAction,
    hasVariable,
} from '@core/_utils/tools.utils';
import { format } from '@core/_utils/date.utils';
import { MessagesService } from '@core/_services/messages.service';
import { ConfirmationService } from 'primeng/api';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { EditorService } from '@service/editor.service';
import { FormatRequestTools } from '@service/formatrequest.tools';
import { indexInputMode } from '../_const/const';
import { TranslateService } from '@ngx-translate/core';
import { DynIndexService } from '@service/dynindex.service';
import { VariableListService } from '@service/variablelist.service';
import { ParseService } from '@service/parse.service';
import { Router } from '@angular/router';
import {LoadingService} from "@core/_services/loading.service";
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { IndexedDbService } from '@service/indexeddb.service';

@Component({
    selector: 'transbsk',
    templateUrl: 'transbsk.component.html',
    styleUrls: ['transbsk.component.scss'],
})
export class TransBskComponent implements OnInit, OnChanges {
    @Input() public currentAction;
    @Input() public bskMode;
    @Input() public currentSelectedBsk;
    @Input() public currentTransfertBsk;
    @Input() public infosMail;
    @Input() public displayDate;
    @Input() public nbDoc;
    @Input() public actionGroup;
    @Input() public docIdList: any[];
    @Input() public docIndex;
    @Input() public sendToBsk;    
    @Input() public currentAtf;    
    @Input() public internalPrefUsr;
    
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onAction: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSwitchTransfert: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public updateIndex: boolean = false;
    public itemConfirm: ItemConfirmComponent;
    public noInputMod = indexInputMode[1];
    public variableListTransfert;
    public editorService: EditorService;
    public parseService: ParseService;
    public variableListService: VariableListService;
    public dynIndexService: DynIndexService;
    public displayVar: boolean = false;

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private formatRequestTools: FormatRequestTools,
        private translate: TranslateService,
        private _router: Router,
        private loadingService: LoadingService,
        private indexedDbService: IndexedDbService
    ) {
        this.visible = false;
        this.variableListTransfert = [];
        this.parseService = new ParseService(this._router);
        this.variableListService = new VariableListService(this.parseService, this.indexedDbService);
        this.dynIndexService = new DynIndexService;
        this.editorService = new EditorService(this.dynIndexService, this.variableListService, this.translate, this.indexedDbService);
    }

    public ngOnInit() {
        this.variableListTransfert = [];
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.updateIndex = false;
        this.displayVar = false;
        if (this.actionGroup) {
            this.infosMail = setInfosMail(true, null, this.translate);
        } else {
            if (this.bskMode === true) {
                this.updateIndex = true;
            }
        }
    }

    public ngOnChanges() {
        if (this.visible === true) {
            this.getVariableListTransfert(this.currentTransfertBsk.bskTypeSearch, this.currentTransfertBsk.bskName)
            .then(() => {                
                this.displayVar = hasVariable(this.variableListTransfert);
                this.onUpdateVar();
            });
        }
    }

    public ngOnDestroy() {
        this.parseService = null;
        this.variableListService = null;
        this.dynIndexService = null;
        this.editorService = null;
    }

    private async getVariableListTransfert(aBskType, aBskName) {
        let wRes: any;
        this.variableListTransfert = [];
        this.editorService.setMode(true);
        this.editorService.variableListService.parseService.setBasketName(aBskName);
        this.editorService.variableListService.parseService.setVariable(this.docIndex);

        try {
            wRes = await lastValueFrom(this.getVarTrsBsk(aBskType, aBskName));      
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant(error.error.CodeMessage));
            return;
        }
        this.editorService.setCustomEditorList(wRes.getEditorList.CustomEditorList);
        this.variableListTransfert = formatVariableTransfert(wRes.getBskVariableList);
        this.variableListTransfert = this.editorService.setVariableTransfert(
            this.actionGroup,
            this.variableListTransfert,
            this.docIndex
        );
        this.currentAction = 'transfert';
        this.visible = true;
    }

    private getVarTrsBsk(aBskType, aBskName) {
        const wDataRequest = { 
            baskettype: aBskType, basketname: aBskName };
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('getbskvariablelist', wDataRequest)
        ]).pipe(
            map(([getEditorList, getBskVariableList]) => {
                return { getEditorList, getBskVariableList };
            })
        );
    }

    public onUpdateVar() {
        if (!this.shouldExecuteAction()) {
            return;
        }        
        if (this.displayVar === false) {
            if (this.currentTransfertBsk.bskAllowActions === 'Move') {
                this.execApplyTrans('move', this.updateIndex, this.currentTransfertBsk.bskIndexInputMode);
            } else if (this.currentTransfertBsk.bskAllowActions === 'Copy') {
                this.execApplyTrans('copy', this.updateIndex, this.currentTransfertBsk.bskIndexInputMode);
            }            
        }
    }	
    
    private shouldExecuteAction(): boolean {
        return this.internalPrefUsr.displayConfirm !== true
            && this.bskMode === true
            && this.sendToBsk === false
            && this.actionGroup === false;
    }

    public onApplyTrans(action) {
        if (this.actionGroup && this.updateIndex) {
            this.itemConfirm.confirmAction(
                'transbsk',
                this.translate.instant('Confirm_1'),
                () => {
                    this.execApplyTrans(action, this.updateIndex, this.currentTransfertBsk.bskIndexInputMode);
                }
            );
        } else {
            this.execApplyTrans(action, this.updateIndex, this.currentTransfertBsk.bskIndexInputMode);
        }
    }

    private execApplyTrans(action, aUpdateIndex, bskIndexInputMode) {
        let wVarListUpdate = new Array();
        wVarListUpdate = [];

        wVarListUpdate = this.editorService.setValueForUpdate(this.variableListTransfert);
        if (aUpdateIndex === true && bskIndexInputMode !== indexInputMode[1]) {
            if (verifyPattern(wVarListUpdate, this.editorService, this._messageService, this.translate) === false) {
                return false;
            }
            if (bskIndexInputMode === indexInputMode[2]) {
                if (verifyDataEnter(wVarListUpdate, this.editorService, this._messageService, this.translate) === false) {
                    return;
                }
            }
        }
        let wInfoMail = new Object();
        if (this.currentTransfertBsk.bskType === 'btMail') {
            this.infosMail.mailActionLabel = this.translate.instant('Mail_' + this.infosMail.mailAction);
            this.execTransBskMail('mail' + action, aUpdateIndex, this.currentTransfertBsk.bskLabel);
        } else {
            wInfoMail = {
                SrcBasketName: this.currentSelectedBsk.bskName,
                dstBasketName: this.currentTransfertBsk.bskName,
                bskType: this.currentTransfertBsk.bskType,
            };
            this.variableListTransfert = [];
            this.variableListTransfert = [...wVarListUpdate];

            this.execTrans(action, wInfoMail, aUpdateIndex, this.currentTransfertBsk.bskLabel);
        }
    }

    private execTransBskMail(action, aUpdateIndex, aBskLabel) {
        let wDateLim = '';
        let wInfoMail = new Object();
        if (this.infosMail.mailLimit === true) {
            wDateLim = format(this.infosMail.dateLimit);
        }
        wInfoMail = {
            mailAction: this.infosMail.mailAction,
            status: this.infosMail.status,
            SrcBasketName: this.currentSelectedBsk.bskName,
            dstBasketName: this.currentTransfertBsk.bskName,
            bskType: this.currentTransfertBsk.bskType,
            msgId: '',
            mailLimit: wDateLim,
            mailUrg: this.infosMail.mailUrgent,
            mailConf: this.infosMail.mailConf,
        };
        this.execTrans(action, wInfoMail, aUpdateIndex, aBskLabel);
    }

    private execTrans(action, wInfoMail, aUpdateIndex, aBskLabel) {        
        if (action === 'mailaddbsk' || action === 'addbsk') {
            this.execSendToBsk(action, wInfoMail, aUpdateIndex, aBskLabel);
        } else {
            this.execTransList(action, wInfoMail, aUpdateIndex, aBskLabel);
        }
    }

    private async execSendToBsk(action, wInfoMail, aUpdateIndex, aBskLabel) {
        let wRes: any;
        let wNbError = 0;
        let wRequest = '';
        this.loadingService.initProgressBar(this.docIdList.length, 1);
        this.formatRequestTools.clear(this.docIdList[0].doc_docid);
        
        wRequest = this.formatRequestTools.sendBasket(this.editorService, this.variableListTransfert, true, wInfoMail, this.currentAtf);
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('sendbsk', wRequest));
            if (wRes.Status === 'ERROR') {
                throw new Error();
            }
        } catch (error) {
            wNbError++;
        }
        this.onAction.emit({
            nbDoc: this.nbDoc,
            action: action,
        });
        this.displayEndTrans(wNbError, action, aBskLabel);

    }

    private async execTransList(action, wInfoMail, aUpdateIndex, aBskLabel) {
        let wNbError = 0;
        let wRequest = '';
        let wRequestBsk = '';
        let wRes: any;
        let wResBsk: any;
        let wListUpdate = [];
        let wAction: string;

        if (aUpdateIndex) {
            this.loadingService.initProgressBar(this.docIdList.length, 2);
        } else {
            this.loadingService.initProgressBar(this.docIdList.length, 1);
        }

        for (const item of this.docIdList) {
            if (aUpdateIndex) {
                this.formatRequestTools.clear(item.doc_docid);
                wRequest = this.formatRequestTools.setIndex(this.editorService, this.variableListTransfert, true);
                try {
                    wRes = await lastValueFrom(this.api.execUrlAction('index', wRequest));
                    if (wRes.Status === 'ERROR') {
                        throw new Error();
                    }
                } catch (error) {
                    wNbError++;
                }
            }
            this.formatRequestTools.clear(item.doc_docid);
            this.formatRequestTools.action = action;
            this.formatRequestTools.currentDocName = item.doc_name;
            wRequestBsk = this.formatRequestTools.actionUpdate(wInfoMail);            
            wAction = getInternalAction(action);
            try {
                wResBsk = await lastValueFrom(this.api.execUrlAction(wAction, wRequestBsk));
                if (wResBsk.Status === 'OK') {
                    wResBsk.status = true;    
                } else {
                    throw new Error();
                }
            } catch (error) {
                wNbError++;
                wResBsk.status = false;
            }
            if (wResBsk.status === true) {
                const wParams = { Docid: item.doc_docid };
                try {
                    wRes = await lastValueFrom(this.api.execUrlAction('unlockdocuments', wParams));
                    if (wRes.Status === 'ERROR') {
                        throw new Error();
                    }
                } catch (error) {
                    wNbError++;
                    wResBsk.status = false;
                }
            }   
            if (action === 'mailmove' || (action === 'move' && wNbError === 0)) {
                this.nbDoc--;
                wListUpdate.push({
                    res: wResBsk.status,
                    request: wRequestBsk,
                    docId: item.doc_docid,
                });
            }
        }

        this.onAction.emit({
            nbDoc: this.nbDoc,
            action: action,
            listUpdate: wListUpdate,
        });

        this.displayEndTrans(wNbError, action, aBskLabel);
    }

    private displayEndTrans(aNbError, aAction, aBskLabel) {
        this.loadingService.resetLoader();
        if (aNbError === 0) {
            this._messageService.addSuccess(this.getDetailMsg(aAction, aBskLabel));
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Work_KO'));
        }
    }

    private getDetailMsg(aAction, aBskLabel) {
        switch (aAction) {
            case 'mailmove':
            case 'move': {
                return this.translate.instant('Bsk_Trs_1', {label: aBskLabel});
            }
            case 'mailcopy':
            case 'copy': {
                return this.translate.instant('Bsk_Trs_2', {label: aBskLabel});
            }
            case 'mailduplicate':
            case 'duplicate': {
                return this.translate.instant('Bsk_Trs_3', {label: aBskLabel});
            }
            case 'mailaddbsk':
            case 'addbsk': {
                return this.translate.instant('Bsk_Trs_5', {label: aBskLabel});
            }
            default: {
                return this.translate.instant('Bsk_Trs_4', {label: aBskLabel});
            }
        }
    }

    public switchTransfert() {
        this.onSwitchTransfert.emit();
        this.close('move');
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit(event);
    }
}
